import axios from "axios";

export interface StudentRow {
  studentId: string;
  admissionNumber: string;
  scholarNumber: string | null;
  studentName: string;
  class: string;
  section: string;
  linkedBranch: string | null;
  isPrimaryBranch: boolean;
}

export interface BranchItem {
  id: string;
  branchName: string | null;
  branchCode: string;
}

export interface LinkPayload {
  studentId: string;
  branchId: string;
  academicSessionId: string;
  isPrimaryBranch?: boolean;
  linkReason?: string;
  linkedDate: string;
}

export interface UpdateLinkPayload {
  branchId?: string;
  isPrimaryBranch?: boolean;
  linkReason?: string;
  linkedDate?: string;
}

export const studentBranchLinkApi = {
  getStudents: async (filters: { sessionId: string; classId?: string; sectionId?: string }) => {
    const res = await axios.get<StudentRow[]>("/scholar-register/student-branch-link/students", {
      params: filters,
    });
    return res.data;
  },
  getBranches: async () => {
    const res = await axios.get<BranchItem[]>("/system-settings/branches");
    return res.data;
  },
  createLink: async (payload: LinkPayload) => {
    const res = await axios.post("/scholar-register/student-branch-link", payload);
    return res.data;
    },
  updateLink: async (id: string, payload: UpdateLinkPayload) => {
    const res = await axios.patch(`/scholar-register/student-branch-link/${id}`, payload);
    return res.data;
  },
  deleteLink: async (id: string) => {
    const res = await axios.delete(`/scholar-register/student-branch-link/${id}`);
    return res.data;
  },
};
